import { FC } from 'react'
import styles from './index.module.scss'
import { Avatar } from '../../atoms/Avatar'
import VerifiedBadgeSvg from '../../../public/images/common/verified_badge.svg'

type Props = {
  avatar: string
  name: string
  isVerifiedAccount?: boolean
}

export const AvatarWithVerifiedBadge: FC<Props> = ({ avatar, name, isVerifiedAccount }) => {
  return (
    <div className={styles.avatar}>
      <Avatar src={avatar} alt={name} isOutline />
      {isVerifiedAccount && (
        <div className={styles.badge}>
          <VerifiedBadgeSvg />
        </div>
      )}
    </div>
  )
}
